<template>
    <div class="footer pl-0 pr-0 container-fluid shared-footer">
        <div class="footer-content pb-1 pt-1 rounded text-center">Dot Care {{myVersion.version}} &copy; Copyright {{currentYear}}, AHBS.</div>
    </div>
</template>

<script>
 
    export default{
          data(){
              return{
                  myVersion: null || "",
                  currentYear: new Date().getFullYear()
              }
        },
        created() {
            this.getVersion();
        },
        methods: {
            getVersion() {

                fetch('/FooterData.json').then(res => res.json()).then(config => {
                     this.myVersion = config;
                });
            }
        }
         
      }
</script>
<style lang="scss" scoped>
    .report-module .container-fluid.shared-footer {
        display: none !important;
    }
</style>